import { DecisionActionRequest } from "../../models/home";

/** Normalizes action inputs into the middleware transport contract. */
export class HomeDecisionActionRequestFactory {
  build(event: { actionKey: string; request?: DecisionActionRequest }): DecisionActionRequest {
    const normalized = event.actionKey.toLowerCase();
    const request: DecisionActionRequest = {
      ...(event.request ?? {}),
      action: event.request?.action ?? event.actionKey,
      clientTraceId: event.request?.clientTraceId ?? `home-${Date.now()}`
    };
    if (!request.payload) {
      if (normalized === "postpone" || normalized.includes("snooze") || normalized.includes("wait")) {
        request.payload = {
          days: this.resolvePostponeDays(request),
          ...(request.reason ? { reason: request.reason } : {}),
          ...(request.notes ? { notes: request.notes } : {})
        };
      } else if (normalized === "assign" && request.assignedToUserId) {
        request.payload = {
          assignedToUserId: request.assignedToUserId,
          ...(request.reason ? { reason: request.reason } : {}),
          ...(request.notes ? { notes: request.notes } : {})
        };
      } else if (normalized === "complete") {
        request.payload = {
          ...(request.reason ? { reason: request.reason } : {}),
          ...(request.notes ? { notes: request.notes } : {}),
          ...(request.completionEvidence !== undefined ? { completionEvidence: request.completionEvidence } : {})
        };
      } else if (normalized === "discard" || normalized.includes("dismiss")) {
        request.payload = {
          ...(request.reason ? { reason: request.reason } : {}),
          ...(request.notes ? { notes: request.notes } : {})
        };
      }
    }
    return request;
  }

  resolvePostponeDays(request: DecisionActionRequest): number {
    const fallbackDate = request.snoozedUntil ?? request.waitingUntil;
    if (!fallbackDate) return 1;
    const target = new Date(fallbackDate);
    return Number.isNaN(target.getTime())
      ? 1
      : Math.max(1, Math.ceil((target.getTime() - Date.now()) / (24 * 60 * 60 * 1000)));
  }
}
